import React from 'react';

import ButtonGroup from '@atlaskit/button/button-group';
import Button from '@atlaskit/button/standard-button';

import { HelpPanelOpenButton } from '@qality/common-components/src/molecules/HelpPanelOpenButton';
import { DOCUMENTATION_LINK } from '@qality/common-config/src/constants';

interface DashboardActionsViewProps {
  projectName: string;
  nameSuffix: string;
  openPageInNewTab: (pageUrl: string) => void;
  openCreateTestCaseDialog: () => void;
}

export const DashboardActionsView: React.FC<DashboardActionsViewProps> = ({
  projectName,
  nameSuffix,
  openPageInNewTab,
  openCreateTestCaseDialog,
}: DashboardActionsViewProps) => {
  return (
    <ButtonGroup>
      {projectName && (
        <Button
          appearance='primary'
          onClick={openCreateTestCaseDialog}
          css={undefined}
        >
          Create Test Case
        </Button>
      )}
      <Button
        onClick={() => {
          openPageInNewTab(DOCUMENTATION_LINK);
        }}
        css={undefined}
      >
        Documentation
      </Button>
      {nameSuffix && (
        <Button
          onClick={() => {
            openPageInNewTab(plugin.servicedeskUrl);
          }}
          css={undefined}
        >
          Contact Support
        </Button>
      )}
      <HelpPanelOpenButton />
    </ButtonGroup>
  );
};
